import React from 'react';

const SubTitle = ({ text }) => {
  return (
    <h3 className='detail-subtitle'>
      {text}
    </h3>
  )
}

export default SubTitle;
